"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var List_meta_1 = require("../List.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', List_meta_1.LIST_CATEGORY_KEY, List_meta_1.LIST_COMPONENT_KEY, ['placeholder']);